import "../scss/my.scss";

import streetMap from "./modules/footer/map";
import { mainMenu } from "./modules/header/mainMenu";
import fixedHeader from "./modules/header/fixedHeader";
import singleProductGallery from "./modules/woocommerce/single-product-gallery";
import categoriesListActive from "./modules/categories-list-active";
import singleProductDisableSubmit
    from './modules/woocommerce/single-product/single-product-disable-submit';

document.addEventListener("DOMContentLoaded", function () {
  streetMap();
  mainMenu();
  fixedHeader();
  categoriesListActive();

  if (document.querySelector(".single-product")) {
    setTimeout(() => {
      singleProductGallery();
    }, 1000);
  }
  if(document.querySelector('.summary__add-to-cart .single_add_to_cart_button')){
    singleProductDisableSubmit();
  }
  // if (document.querySelector('.home-intro') && window.innerWidth > 992) {
  //     homeIntroAnimation();
  // }
  // footerAnimation();
});
